"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/ComposerSendButton.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);


const SEND_LATER_ON = Object.freeze({ enabled: true })




















// Send ▾: two buttons. The chevron opens Send later and is only rendered
// while the Schedule action is visible.
const ComposerSendButton = ({
  disabled, gate, isEmpty, showSendLater, sendLaterState = SEND_LATER_ON, label, onSend, onSendLater,
}) => {
  const reasonId = _react.useId.call(void 0, )
  const laterReasonId = _react.useId.call(void 0, )
  const blocked = !disabled && gate.blocked
  const describedBy = blocked && gate.reason ? reasonId : undefined
  const laterOff = blocked || !sendLaterState.enabled
  const laterReason = !disabled && !blocked ? sendLaterState.reason : undefined
  const laterDescribedBy = describedBy || (laterReason ? laterReasonId : undefined)

  return (
    _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, 'composer-send', showSendLater && 'composer-send--split'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 41}}
      , _react2.default.createElement('button', {
        type: "button",
        className: _classBuilder2.default.call(void 0, 'composer-send--button', !label && 'composer-send--icon', (isEmpty || blocked) && 'composer-send--dimmed'),
        'aria-label': label ? undefined : 'Send',
        disabled: disabled,
        'aria-disabled': blocked || (!disabled && isEmpty) || undefined,
        'aria-describedby': describedBy,
        title: blocked ? gate.reason : label ? undefined : 'Send',
        onClick: onSend, __self: this, __source: {fileName: _jsxFileName, lineNumber: 42}}

        , label || _react2.default.createElement('i', { className: "material-icons", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 52}}, "send")
      )
      , showSendLater && (
        _react2.default.createElement('button', {
          type: "button",
          className: _classBuilder2.default.call(void 0, 'composer-send--more', laterOff && 'composer-send--dimmed'),
          'aria-label': "Send later options"  ,
          'aria-haspopup': "dialog",
          disabled: disabled,
          'aria-disabled': laterOff || undefined,
          'aria-describedby': laterDescribedBy,
          title: blocked ? gate.reason : laterReason,
          onClick: onSendLater, __self: this, __source: {fileName: _jsxFileName, lineNumber: 55}}

          , _react2.default.createElement('i', { className: "material-icons", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 66}}, "expand_more")
        )
      )
      , describedBy && _react2.default.createElement('span', { id: reasonId, className: "composer--sr-only", __self: this, __source: {fileName: _jsxFileName, lineNumber: 69}}, gate.reason)
      , !describedBy && laterReason && _react2.default.createElement('span', { id: laterReasonId, className: "composer--sr-only", __self: this, __source: {fileName: _jsxFileName, lineNumber: 70}}, laterReason)
    )
  )
}

exports. default = _react.memo.call(void 0, ComposerSendButton)
